import React from 'react';
import { Wine } from 'lucide-react';

export default function BarHero() {
  const scrollToGenerator = () => {
    document.getElementById('bar-generator')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <div className="relative">
      <div className="absolute inset-0">
        <img
          className="w-full h-full object-cover"
          src="https://images.unsplash.com/photo-1470337458703-46ad1756a187?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=2070&q=80"
          alt="Stylish bar interior"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-amber-900 to-amber-800 opacity-75"></div>
      </div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 text-center">
        <div className="flex justify-center mb-6">
          <Wine className="w-16 h-16 text-amber-400" />
        </div>
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
          Bar Name Generator
        </h1>
        <p className="text-xl text-amber-100 mb-8 max-w-3xl mx-auto">
          Create the perfect name for your bar with our AI-powered generator.
          From speakeasies to sports bars, we've got you covered.
        </p>
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          <span className="bg-white/20 px-4 py-2 rounded-full text-white text-sm">
            Pub Names
          </span>
          <span className="bg-white/20 px-4 py-2 rounded-full text-white text-sm">
            Cocktail Lounges
          </span>
          <span className="bg-white/20 px-4 py-2 rounded-full text-white text-sm">
            Sports Bars
          </span>
        </div>
        <button 
          onClick={scrollToGenerator}
          className="bg-amber-500 text-white text-lg px-8 py-4 rounded-lg hover:bg-amber-600 transition-colors cursor-pointer"
        >
          Generate Bar Names
        </button>
        <p className="mt-4 text-sm text-amber-200">
          Trusted by over 1,000+ bar owners worldwide
        </p>
      </div>
    </div>
  );
}